import { AiOutlineInfoCircle } from 'react-icons/ai';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { getParamsDD } from '../../utils/GridParams';
import { ColumnsType } from '../../utils/Types/types';
import * as React from "react";
const isRejected = (args: any) => {
  let isChecked = args.isRejected;
  let theCurrenColor = 'purple';
  let theText = '';
  if (args.taskData.reason) {
    let theParseReason = args.taskData.reason.split('^&&');
    let theParsingReasonFromArray = theParseReason[0].split('$');
    theText = theParsingReasonFromArray[0];
    if (theParsingReasonFromArray.length > 0) {
      theCurrenColor = theParsingReasonFromArray[1];
    }
  }
  return (
    <div>
      {isChecked ? (
        <div>
          <TooltipComponent
            content={() => {
              return (
                <a>
                  <AiOutlineInfoCircle
                    size={20}
                    color=''
                    style={{ marginLeft: 5 }}
                  />
                  <span style={{ color: 'black' }}>{theText}</span>
                </a>
              );
            }}
            style={{
              display: 'inline-block',
              padding: '5px',
              color: 'black',
              marginLeft: 5,
            }}
          >
            <div
              style={{ width: 25, height: 25, backgroundColor: theCurrenColor }}
            ></div>
          </TooltipComponent>
        </div>
      ) : null}
    </div>
  );
};
export const columns: ColumnsType[] = [
  {
    displayAsCheckBox: true,
    type: 'checkbox',
    width: 45,
    field: 'isChecked',
  },
  {
    width: 50,
    field: 'pronto_row_id',
    headerText: 'Task ID',
    visible: false,
    allowEditing: false,
  },
  {
    field: 'priority_code',
    headerText: 'Priority',
    width: 67,
    visible: true,
    allowEditing: false,
  },
  {
    field: 'isEffected',
    textAlign: 'Left',
    width: 50,
    visible: false,
    clipMode: 'EllipsisWithTooltip',
    type: 'boolean',
  },
  {
    width: 200,
    field: 'TaskID',
    headerText: 'Task ID',
    isPrimaryKey: true,
    visible: false,
    allowEditing: false,
  },
  {
    field: 'asset_code',
    headerText: 'Asset',
    width: 140,
    allowEditing: false,
  },
  {
    field: 'order_code',
    headerText: 'Order#',
    width: 100,
    allowEditing: false,
  },

  {
    field: 'operationSequence',
    headerText: 'Operation Sequence',
    width: 60,
    allowEditing: false,
  },
  {
    field: 'TaskName',
    headerText: 'Job Name',
    clipMode: 'EllipsisWithTooltip',
    width: 400,
  },
  {
    field: 'tradeCode',
    headerText: 'Trade',
    width: 95,
    allowEditing: true,
    edit: getParamsDD(
      { text: 'trade_code', value: 'trade_id' },
      'tradeCode',
      'trade'
    ),
  },
  {
    field: 'required',
    headerText: 'Reqd',
    width: 60,
    allowEditing: true,
    type: 'numeric',
    format: 'c2',
    editType: 'numericedit',
    edit: { params: { min: 1, max: 10000 } },
  },
  {
    field: 'Duration',
    headerText: 'Dur',
    width: 60,
    visible: false,
  },
  {
    field: 'Work',
    headerText: 'Work',
    width: 90,
    edit: { params: { min: 0, max: 10000 } },
  },
  {
    width: 150,
    field: 'StartDate',
    // format:'dd/MM/yyyy HH:mm',
  },
  {
    width: 150,
    field: 'EndDate',
    // format:'dd/MM/yyyy HH:mm',
  },
    {
    field: 'teamCode',
    headerText: 'Team',
    width: 90,
    allowEditing: true,
    edit: getParamsDD(
      { text: 'team_code', value: 'team_id' },
      'teamCode',
      'team'
    ),
  },
  {
    width: 90,
    field: 'shift',
    headerText: 'Shift',
    allowEditing: true,
    edit: getParamsDD(
      { text: 'rosterCode', value: 'rosterId' },
      'shift',
      'shift'
    ),
  },

  {
    field: 'department_code',
    headerText: 'Department',
    width: 110,
    allowEditing: true,
  },

  {
    field: 'status_code',
    headerText: 'Status Code',
    width: 65,
    visible: true,
    allowEditing: true,
    edit: getParamsDD(
      { value: 'value', text: 'alias' },
      'status_code',
      'global-filter?where=operation$status$isEnabled€1'
    ),
  },
  {
    width: 40,
    field: 'type_code',
    headerText: 'Type',
    visible: false,
    allowEditing: false,
  },
  {
    width: 70,
    field: 'order_resp_code',
    headerText: 'Resp',
    allowEditing: true,
    edit: getParamsDD(
      { value: 'sys_tbl_code', text: 'sys_description' },
      'order_resp_code',
      'system-config?where=P2'
    ),
  },

  {
    width: 60,
    field: 'Progress',
    visible: false,
  },
  {
    width: 80,
    field: 'planned_by',
    headerText: 'Planned By',
    visible: false,
  },
  {
    visible: false,
    field: 'description',
    headerText: 'WO Description',
  },
  {
    width: '150',
    field: 'site_details_1',
    headerText: 'Asset Type',
    visible: false,
  },
  {
    width: '250',
    field: 'long_description',
    headerText: 'Op. Description',
    visible: false,
  },
  {
    width: '150',
    field: 'description',
    headerText: 'WO Description',
    visible: false,
  },
  {
    width: '150',
    field: 'Predecessor',
    visible: false,
  },
  {
    width: 70,
    field: 'isRejected',
    headerText: 'ISRESCHEDULED',
    visible: true,
    allowEditing: false,
    template: isRejected,
  },
  {
    width: 70,
    field: 'isDone',
    headerText: 'ISDONE',
    visible: false,
    allowEditing: false,
  },
];
const orderCodeTemplate = (args: any) => {
  const data = args.taskData;
  const orderCode = data.order_code;
  let tooltipText = '';
  if (data.commitFailedMessage) {
    tooltipText = data.commitFailedMessage.replace(new RegExp('^' + orderCode), '').trim();
  }
  return (
      <span
          className={`order-code-cell ${data?.commitFailedMessage ? 'error' : ''}`}
          title={tooltipText}
      >
            {orderCode}
        </span>
  );
};
export const schedulerColumns: ColumnsType[] = [
  {
    displayAsCheckBox: true,
    type: 'checkbox',
    width: 45,
    field: 'isChecked',
  },
  {
    width: 50,
    field: 'pronto_row_id',
    headerText: 'Task ID',
    visible: false,
    allowEditing: false,
  },
  {
    field: 'priority_code',
    headerText: 'Priority',
    width: 67,
    visible: true,
    allowEditing: false,
  },
  {
    field: 'isEffected',
    textAlign: 'Left',
    width: 50,
    visible: false,
    clipMode: 'EllipsisWithTooltip',
    type: 'boolean',
  },
  {
    width: 200,
    field: 'TaskID',
    headerText: 'Task ID',
    isPrimaryKey: true,
    visible: false,
    allowEditing: false,
  },
  {
    field: 'asset_code',
    headerText: 'Asset',
    width: 140,
    allowEditing: false,
  },
  {
    field: 'order_code',
    headerText: 'Order#',
    width: 100,
    allowEditing: false,
    template: orderCodeTemplate.bind(this),
  },

  {
    field: 'operationSequence',
    headerText: 'Operation Sequence',
    width: 60,
    allowEditing: false,
  },
  {
    field: 'TaskName',
    headerText: 'Job Name',
    clipMode: 'EllipsisWithTooltip',
    width: 400,
  },
  {
    field: 'tradeCode',
    headerText: 'Trade',
    width: 95,
    allowEditing: false,
    edit: getParamsDD(
      { text: 'trade_code', value: 'trade_id' },
      'tradeCode',
      'trade'
    ),
  },
  {
    field: 'required',
    headerText: 'Reqd',
    width: 90,
    allowEditing: true,
    type: 'numeric',
    format: 'c2',
    editType: 'numericedit',
    edit: { params: { min: 1, max: 10000 } },
  },
  {
    field: 'Duration',
    headerText: 'Dur',
    width: 90,
  },
  {
    field: 'Work',
    headerText: 'Work',
    width: 90,
    edit: { params: { min: 0, max: 10000 } },
  },
  {
    width: 150,
    field: 'StartDate',
    // format:'dd/MM/yyyy HH:mm',
  },
  {
    width: 150,
    field: 'EndDate',
    // format:'dd/MM/yyyy HH:mm',
  },
    {
    field: 'teamCode',
    headerText: 'Team',
    width: 90,
    allowEditing: false,
    edit: getParamsDD(
      { text: 'team_code', value: 'team_id' },
      'teamCode',
      'team'
    ),
  },
  {
    width: 90,
    field: 'shift',
    headerText: 'Shift',
    allowEditing: false,
    edit: getParamsDD(
      { text: 'rosterCode', value: 'rosterId' },
      'shift',
      'shift'
    ),
  },

  {
    field: 'department_code',
    headerText: 'Department',
    width: 110,
    allowEditing: false,
  },

  {
    field: 'wo_status_code',
    headerText: 'WO Status Code',
    width: 65,
    visible: true,
    allowEditing: true,
    edit: getParamsDD(
      { value: 'value', text: 'alias' },
      'status_code',
      'global-filter?where=operation$status$isEnabled€1'
    ),
  },
  {
    width: 40,
    field: 'type_code',
    headerText: 'Type',
    visible: false,
    allowEditing: false,
  },
  {
    width: 70,
    field: 'order_resp_code',
    headerText: 'Resp',
    allowEditing: true,
    edit: getParamsDD(
      { value: 'sys_tbl_code', text: 'sys_description' },
      'order_resp_code',
      'system-config?where=P2'
    ),
  },

  {
    width: 60,
    field: 'Progress',
    visible: false,
  },
  {
    width: 80,
    field: 'planned_by',
    headerText: 'Planned By',
    visible: false,
  },
  {
    visible: false,
    field: 'description',
    headerText: 'WO Description',
  },
  {
    width: '150',
    field: 'site_details_1',
    headerText: 'Asset Type',
    visible: false,
  },
  {
    width: '250',
    field: 'long_description',
    headerText: 'Op. Description',
    visible: false,
  },
  {
    width: '150',
    field: 'description',
    headerText: 'WO Description',
    visible: false,
  },
  {
    width: '150',
    field: 'Predecessor',
    visible: false,
  },
  {
    width: 70,
    field: 'isRejected',
    headerText: 'ISRESCHEDULED',
    visible: true,
    allowEditing: false,
    template: isRejected,
  },
  {
    width: 70,
    field: 'isDone',
    headerText: 'ISDONE',
    visible: false,
    allowEditing: false,
  },
  {
    width: 50,
    field: 'dependentTaskId',
    headerText: 'dependentTaskId',
    visible: false,
    allowEditing: false,
  },
  {
    width: 50,
    field: 'pm_schedule_id',
    headerText: 'PM Schedule ID',
    visible: false,
    allowEditing: false,
  },
  {
    width: 200,
    field: 'uniqueDependencyCode',
    headerText: 'uniqueDependencyCode',
    visible: false,
    allowEditing: false,
  },
];

export const editDialogFields = [
  {
    type: 'General',
    headerText: 'General',
  },
  { type: 'Dependency' },
  { type: 'Resources' },
  { type: 'Notes' },
  { type: 'Segments' },
];
